
<div class="contentWrapper">
    <div class="logo">
        <div class="Wrapper">
            <!-- <span>flowtrics</span> -->
            <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div> 
    </div>   
    <div class="Wrapper">
        <h3>Thank You for your Information.</h3>
        <!-- <h5>You will receive an email containing a link to complete the forms requested.</h5> -->
        <h5>If the email isn't in your inbox, please review your spam folder. If you still haven't received it, reach out to support@flowtrics.com.</h5>

        <div class="emailImg">
            <img src="../../../assets/images/thanksEmail.png" alt="">
        </div>
        <!-- <a class="register" href="http://flowtrics.com/"  mat-stroked-button color="primary"  type="button">Get Started</a> -->
    </div> 
</div>

